import useGutType from 'services/gutType/useGutType';
import useCurrentKitAndTinyAccount from 'hooks/useCurrentKitAndTinyAccount';
import { KitType } from '@repo/types';

import { Card, Icon, Typography } from 'components';
import { CardErrorBoundaryWithSpinfinity } from 'components/Card/CardErrorBoundaryWithSpinfinity';
import { MicrobiomeBar } from 'views/Results/Microbiome/MicrobiomeBar';

import styles from './GutTypeCard.module.scss';

const GutTypeCardContent = () => {
  const { currentKit } = useCurrentKitAndTinyAccount();
  const { gutType } = useGutType();

  const isVaginal = currentKit?.sampling_type === KitType.VAGINAL;

  if (!currentKit) return null;
  
  return (
    <div className='flex flex-column h-100 w-100'>
      <Typography variant='heading-m' className='mb-4'>
        {`${isVaginal ? 'CST' : 'Type'}: ${gutType}`}
      </Typography>
      <MicrobiomeBar kit={currentKit} displayMode='card' />
    </div>
  );
};

export const GutTypeCard = () => {
  const { currentKitId } = useCurrentKitAndTinyAccount();
  
  return (
    <CardErrorBoundaryWithSpinfinity cardName="GutTypeCard">
      <Card
        clickable={{
          href: `/results/${currentKitId}/microbiome`,
          text: 'Microbiome breakdown',
          isExternal: false,
        }}
      >
        <div className={styles.titleContainer}>
          <Typography variant='heading-s' className={styles.textLink}>
            Microbiome breakdown
          </Typography>
          <Icon name='chevronForward' size='s' className={styles.titleIcon} />
        </div>
        <GutTypeCardContent />
      </Card>
    </CardErrorBoundaryWithSpinfinity>
  );
};
